<script lang="ts">
  import Icon from '$components/elements/Icon.svelte';
  import type { LinkInterface } from '$types/interfaces';

  export let link: LinkInterface;
</script>

<a href={link.url} class="footer-link">
  {#if link.icon}
    <Icon icon={link.icon} />
  {/if}
  {link.title}
</a>

<style lang="scss">
  .footer-link {
    display: block;
    line-height: 43px;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 10px;
  }
</style>
